<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import calcInput from 'apps/bankrate-calculators/components/number-input.vue'
import dateInput from 'apps/bankrate-calculators/components/date-input.vue'
import store from './store'
import config from './config'
import calculatorEventBus from 'apps/bankrate-calculators/events'

const template = store.state.isMobile
  ? require('./mobile-template.html')
  : require('./template.html')

export default {
  template,
  store,
  components: { calcInput, dateInput },
  data() {
    return {
      config: config,
      compoundingType: 'daily',
      skipSavings2WeeksYearly: 'no',
      savingsSchedule: [],
      showSavingsSchedule: false,
      monthlyDeposit: 0,
      dailyRequiredSavings: 0,
      weeklyRequiredSavings: 0,
      showSkipOption: false // temporary, to hide the skipOption radios
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'savingsGoal',
      'yearsToSave',
      'interestRate',
      'compoundingOption',
      'firstDeposit',
      'skip2WeeksOption', //@todo - remove once we definitely know not required
      'startDate'
    ]),
    ...mapGetters(['errorsOnPage', 'dataChanged', 'computedFirstDepositMax'])
  },
  methods: {
    setRadioValue(name, value, trackingValue) {
      this.$store.dispatch('setState', { name: name, value: value })
      calculatorEventBus.$emit('fieldChanged', {
        fieldName: this.config[name].title.toLowerCase(),
        value: trackingValue
      })
    },
    triggerCalculate() {
      calculatorEventBus.$emit('calculator:calculation')
      if (!this.errorsOnPage && this.dataChanged) {
        this.$store.dispatch('updatePreviousUserInputs')
        this.calculate()
      }
    },
    calculate() {
      const rate =
        this.interestRate / (this.compoundingOption === 'daily' ? 36500 : 1200)
      const factor = Math.pow(rate + 1, this.yearsToSave * 12)
      const factor2 = rate / (factor - 1)
      let monthlyPayment =
        (this.savingsGoal - this.firstDeposit * factor) * factor2
      let totalInterest = 0
      let balance = this.firstDeposit
      let schedule = []
      let iterations = 0
      let errorInBalance = 1.0

      if (this.savingsGoal - this.firstDeposit <= 0) {
        monthlyPayment = 0
      } else {
        /* Added this while loop based on what I see in the original calculator.
                    // This loop basically tweaks the monthly payment till the balance on the last
                    // month exactly matches the savings goal.
                    // This seems like a hack, not sure whether this way of calculating monthly payment is valid
                    // @todo - more research and / or confirm this with the PO.
                    */
        while (Math.abs(errorInBalance) > 0.004 && iterations++ < 99) {
          totalInterest = 0.0
          balance = this.firstDeposit
          let previousMonth = moment(this.startDate)
          let rowDate = moment(this.startDate)
          rowDate.add(1, 'M')
          let rowInterest = 0

          for (let i = 0; i < this.yearsToSave * 12; i++) {
            // we are adding interest earned over the previous month
            if (this.compoundingOption === 'monthly') {
              rowInterest = balance * rate
              balance += rowInterest
            } else {
              const daysInPrevMonth = previousMonth.daysInMonth()
              rowInterest = 0

              for (let j = 0; j < daysInPrevMonth; j++) {
                rowInterest += balance * rate
                balance += balance * rate
              }
            }

            totalInterest += rowInterest
            balance += monthlyPayment
            schedule[i] = {
              month: rowDate.format('MMM YYYY'),
              deposit: monthlyPayment,
              interest: rowInterest,
              totalInterest: totalInterest,
              balance: balance
            }

            previousMonth.add(1, 'M')
            rowDate.add(1, 'M')
          }

          errorInBalance = this.savingsGoal - balance
          monthlyPayment += errorInBalance * factor2
        }
      }

      let dailyRequiredSavings = (monthlyPayment * 12) / 365
      this.savingsSchedule = schedule
      this.monthlyDeposit = monthlyPayment
      this.dailyRequiredSavings = Math.round(dailyRequiredSavings * 100) / 100
      this.weeklyRequiredSavings =
        Math.round(dailyRequiredSavings * 7 * 100) / 100
    },
    toggleSavingsSchedule(event) {
      this.showSavingsSchedule = !this.showSavingsSchedule
      this.trackClick(event)
    },
    printSavingsSchedule(event) {
      this.trackClick(event)
      const table = document.querySelector('[data-table=savingsSchedule]')
      const printWindow = window.open('')
      printWindow.document.write(table.outerHTML)
      printWindow.print()
      printWindow.close()
    },
    trackClick(event) {
      const fieldName = event.target.innerText.trim().toLowerCase()
      calculatorEventBus.$emit('calculator:engagement', fieldName)
    },
    trackRateRequest() {
      calculatorEventBus.$emit('calculator:requestRateTable')
    }
  },
  watch: {
    compoundingType(type) {
      this.setRadioValue('compoundingOption', type, type)
    },
    skipSavings2WeeksYearly(option) {
      this.setRadioValue('skip2WeeksOption', option, option)
    }
  },
  created() {
    this.$store.dispatch('loadDefaultState', config)
    calculatorEventBus.$on('savingGoalChanged', () => {
      this.$refs.firstDeposit.hasError =
        this.firstDeposit < 1 || this.firstDeposit > this.savingsGoal
    })
    this.calculate()
  }
}
</script>
<style scoped>
.mobile thead {
  line-height: 1;
}
.mobile .calculator__amortization-body td {
  font-size: 0.7rem;
}
</style>
